import { useState, useEffect } from 'react';
import { getDynamicSelectData } from '../../utils/api/data';

const useComponentIds = (role) => {
    const [componentIds, setComponentIds] = useState(null);
  
    useEffect(() => {
      const fetchData = async () => {
        const [{ ROLE_NAME }] = await getDynamicSelectData({
          selectValues: 'ROLE_NAME',
          tableName: 'auth.ROLES',
          whereField: ['ID'],
          whereOperators: ['='],
          whereValue: [role],
          db: 'SQL'
        });
  
        const fetchIDs = async (table) => {
          const data = await getDynamicSelectData({
            selectValues: 'ID',
            tableName: table,
            whereField: ['CUSTOMER'],
            whereOperators: ['='],
            whereValue: [ROLE_NAME],
            db: 'SQL'
          });
          return data.map(({ ID }) => Number(ID));
        };
  
        const widgets = await fetchIDs('auth.WIDGET_ACCESS');
        const charts = await fetchIDs('auth.CHART_ACCESS');
  
        setComponentIds({ widgets, charts });
      };
  
      fetchData();
    }, [role]);
  
    return componentIds;
  };
  
export default useComponentIds;
